export default "__VITE_ASSET__CQZXKG31__"